import payload_plugin_e0k4tW9bdI from "/app/node_modules/nuxt-vuefire/dist/runtime/payload-plugin.mjs";
import revive_payload_client_4sVQNw7RlN from "/app/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/app/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/app/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/app/node_modules/nuxt/dist/app/plugins/payload.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/app/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import plugin_vue3_A0OWXRrUgq from "/app/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/app/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/app/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_client_mik7N71GmK from "/app/node_modules/nuxt-vuefire/dist/runtime/app/plugin.client.mjs";
import vuefire_auth_plugin_client_cCwkwh1j5u from "/app/.nuxt/vuefire-auth-plugin.client.mjs";
import vuefire_plugin_8cq4FnzXKb from "/app/.nuxt/vuefire-plugin.mjs";
import pwa_client_Eorgdr12jA from "/app/node_modules/@vite-pwa/nuxt/dist/runtime/plugins/pwa.client.mjs";
import chunk_reload_client_UciE0i6zes from "/app/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import api_GFfDXud5Cr from "/app/plugins/api.ts";
import calculate_age_uGpDfPdxhf from "/app/plugins/calculate-age.ts";
import date_directive_r3z2wTw24g from "/app/plugins/date-directive.ts";
import error_handler_kEP5FliEXj from "/app/plugins/error-handler.ts";
import event_listener_UL5c6R6znz from "/app/plugins/event-listener.ts";
import excel_56ugge7MPo from "/app/plugins/excel.js";
import gender_tag_uucD9d8vHP from "/app/plugins/gender-tag.ts";
import gsap_qE0fizvEy0 from "/app/plugins/gsap.ts";
import host_message_k3rMQFxyIZ from "/app/plugins/host-message.ts";
import input_tel_yPDVvN7XtG from "/app/plugins/input-tel.ts";
import maska_UHaKf2z1iQ from "/app/plugins/maska.ts";
import policies_directive_SsX5MpUpQl from "/app/plugins/policies-directive.ts";
import resize_verticaly_directive_9csfOfAiVD from "/app/plugins/resize-verticaly-directive.ts";
import survey_client_gSxBExQo8t from "/app/plugins/survey.client.ts";
import survey_INYSjaQfYT from "/app/plugins/survey.ts";
import tel_input_Q0kBctXUuX from "/app/plugins/tel-input.ts";
import toaster_3RwauQEG5B from "/app/plugins/toaster.ts";
import toolkit_Ro0r3mXA0A from "/app/plugins/toolkit.ts";
import translations_DWHk0W6D9U from "/app/plugins/translations.ts";
import vuetify_7h9QAQEssH from "/app/plugins/vuetify.ts";
export default [
  payload_plugin_e0k4tW9bdI,
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  check_outdated_build_client_8vK7RkfGxZ,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_client_mik7N71GmK,
  vuefire_auth_plugin_client_cCwkwh1j5u,
  vuefire_plugin_8cq4FnzXKb,
  pwa_client_Eorgdr12jA,
  chunk_reload_client_UciE0i6zes,
  api_GFfDXud5Cr,
  calculate_age_uGpDfPdxhf,
  date_directive_r3z2wTw24g,
  error_handler_kEP5FliEXj,
  event_listener_UL5c6R6znz,
  excel_56ugge7MPo,
  gender_tag_uucD9d8vHP,
  gsap_qE0fizvEy0,
  host_message_k3rMQFxyIZ,
  input_tel_yPDVvN7XtG,
  maska_UHaKf2z1iQ,
  policies_directive_SsX5MpUpQl,
  resize_verticaly_directive_9csfOfAiVD,
  survey_client_gSxBExQo8t,
  survey_INYSjaQfYT,
  tel_input_Q0kBctXUuX,
  toaster_3RwauQEG5B,
  toolkit_Ro0r3mXA0A,
  translations_DWHk0W6D9U,
  vuetify_7h9QAQEssH
]